// Shared helpers for the cover page renderers (PDF + screen).

const ORG_SUFFIX_PATTERNS: RegExp[] = [
    /\s+(Private Limited)$/i,
    /\s+(Pvt\.?\s*Ltd\.?)$/i,
    /\s+(Public Limited)$/i,
    /\s+(Limited)$/i,
    /\s+(Ltd\.?)$/i,
    /\s+(LLP)$/i,
    /\s+(Inc\.?)$/i,
    /\s+(Corp\.?)$/i,
];

export const splitOrgName = (name: string): { main: string; suffix?: string } => {
    for (const re of ORG_SUFFIX_PATTERNS) {
        const m = name.match(re);
        if (m) return { main: name.replace(re, '').trim(), suffix: m[1] };
    }
    return { main: name };
};
